import React from "react";
export function Overline({
  children,
  light = false
}: {
  children: React.ReactNode;
  light?: boolean;
}) {
  return <p className={`flex items-center gap-2.5 text-[12px] font-medium uppercase tracking-[0.28em] ${light ? "text-white/80" : "text-ink-muted"}`} data-id="element-196" data-mp="280tc6pbgy4o3">
      <span aria-hidden="true" className="h-1.5 w-1.5 bg-brand" data-id="element-197" data-mp="1z1pthmg7rra4" />
      {children}
    </p>;
}